/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './line-item-template-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LineItemBulkActionService} from './line-item-bulk-action.service';
import {AdnResourceListService} from '../common/controller/adn-resource-list.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-line-item-template-list-page',
  template
})
export class LineItemTemplateListPageComponent extends AdminResourceListPageBase {
  // Absolute state (March used relative ".line-item-template" from the list).
  readonly itemStateName = 'app.adv.line-item-templates.line-item-template';
  readonly tierItemStateName = 'app.adm.tiers.tier';

  private readonly fallbackColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'Tier', label: 'tier'},
    {param: 'objectives', numeric: true},
    {param: '', label: 'targeting', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly lineItemBulkActionService: LineItemBulkActionService,
    private readonly listService: AdnResourceListService
  ) {
    super(LocalNetworkProfile);
  }

  get visibleColumns(): AdminListColumn[] {
    return this.normalizeColumns(this.list?.lineItemFields || this.fallbackColumns);
  }

  /** Prefer lineItemFields so headers match the March list / body columns. */
  get sortHeaderParams(): any[] {
    if (this.list?.lineItemFields?.length) {
      return this.list.lineItemFields;
    }
    return super.sortHeaderParams;
  }

  systemLinkDisabled(): boolean {
    return this.list?.perms?.MANAGE_SYSTEM !== true;
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    this.listService.ensureAngularList(this.list);
    if (!this.list.bulkAction) {
      this.list.bulkAction = this.lineItemBulkActionService.createBulkAction(this.list);
    }
  }
}
